export default {
    INITIAL: 1,
    INPROGRESS: 2
};
